import React from 'react';
import { Play } from 'lucide-react';

const DisputeMediaSection = ({
  customerMedia,
  workerProofs,
  baseUrlForFile,
  setPreviewImage,
  setPreviewVideo
}) => {
  return (
    <div className="wc-dispute-media">

      {customerMedia.length > 0 && (
        <>
          <h5>Customer Media</h5>

          <div className="wc-media-grid">
            {customerMedia.map((media) => {
              const ext = media.file?.split('.').pop()?.toLowerCase();
              const isVideo = ["mp4", "webm", "mov", "avi"].includes(ext);

              return isVideo ? (
                <div
                  key={media.id}
                  className="wc-video-thumb"
                  onClick={() => setPreviewVideo(`${baseUrlForFile}/${media.file}`)}
                >
                  <video
                    src={`${baseUrlForFile}/${media.file}`}
                  />

                  <div className="wc-play-icon">
                    <Play size={28} fill="white" />
                  </div>
                </div>
              ) : (
                <img
                  key={media.id}
                  src={`${baseUrlForFile}/${media.file}`}
                  onClick={() => setPreviewImage(`${baseUrlForFile}/${media.file}`)}
                />
              );
            })}
          </div>
        </>
      )}

      {workerProofs.length > 0 && (
        <>
          <h5>Worker Proofs</h5>

          <div className="wc-media-grid">
            {workerProofs.map((media) => {
              const ext = media.file?.split('.').pop()?.toLowerCase();
              const isVideo = ["mp4", "webm", "mov", "avi"].includes(ext);

              return isVideo ? (
                <div
                  key={media.id}
                  className="wc-video-thumb"
                  onClick={() => setPreviewVideo(`${baseUrlForFile}/${media.file}`)}
                >
                  <video
                    src={`${baseUrlForFile}/${media.file}`}
                  />

                  <div className="wc-play-icon">
                    <Play size={28} fill="white" />
                  </div>
                </div>
              ) : (
                <img
                  key={media.id}
                  src={`${baseUrlForFile}/${media.file}`}
                  onClick={() => setPreviewImage(`${baseUrlForFile}/${media.file}`)}
                />
              );
            })}
          </div>
        </>
      )}

    </div>
  );
};

export default DisputeMediaSection;